
import React from 'react';
import Contatti from './Contatti';
import ComposizioneMail from './ComposizioneMail';
import ContattiPrenotazione from './ContattiPrenotazione';
import ContattiPrenotazionePartecipanti from './ContattiPrenotazionePartecipanti';
import ContattiPrenotazioneNuovo from './ContattiPrenotazioneNuovo';
import ContattiPrenotazioneNuovoPartecipanti from './ContattiPrenotazioneNuovoPartecipanti';
import { useNavigate } from 'react-router-dom';
import DebugPrenotazioni from './DebugPrenotazioni';

function formatDateIT(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function Iniziative() {
  const navigate = useNavigate();
  // Stato tab e dati
  const [tab, setTab] = React.useState('generali');
  // Stato per Contatti Generali
  const [selectedRowsGen, setSelectedRowsGen] = React.useState([]);
  const [placeholdersGen, setPlaceholdersGen] = React.useState([]);
  const [destinatariCountGen, setDestinatariCountGen] = React.useState(0);
  const [emailCountGen, setEmailCountGen] = React.useState(0);
  const [contactsKeyGen, setContactsKeyGen] = React.useState(0);
  // Stato per Contatti Prenotazioni
  const [selectedIdManager, setSelectedIdManager] = React.useState(null);
  const [selectedIniziativa, setSelectedIniziativa] = React.useState(null);
  const [selectedPartecipanti, setSelectedPartecipanti] = React.useState([]);
  const [placeholdersPartecipanti, setPlaceholdersPartecipanti] = React.useState([]);
  const [placeholdersIniziativa, setPlaceholdersIniziativa] = React.useState([]);
  const [destinatariCountPartecipanti, setDestinatariCountPartecipanti] = React.useState(0);
  const [emailCountPartecipanti, setEmailCountPartecipanti] = React.useState(0);
  // Stato per Contatti Prenotazioni Nuovo (middleware)
  const [selectedIdNuovo, setSelectedIdNuovo] = React.useState(null);
  const [selectedIniziativaNuova, setSelectedIniziativaNuova] = React.useState(null);
  const [selectedIscrittiNuovo, setSelectedIscrittiNuovo] = React.useState([]);
  const [placeholdersIscrittiNuovo, setPlaceholdersIscrittiNuovo] = React.useState([]);
  const [placeholdersIniziativaNuova, setPlaceholdersIniziativaNuova] = React.useState([]);
  const [destinatariCountNuovo, setDestinatariCountNuovo] = React.useState(0);
  const [emailCountNuovo, setEmailCountNuovo] = React.useState(0);

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div align="left">
              <h1 className="text-success">
                <i className="fas fa-calendar-alt"></i> Gestione Iniziative
              </h1>
              <p className="text-muted">Invia iniziative e progetti agli enti e ai referenti ANUTEL ETS</p>
            </div>
            <div>
              <button className="btn btn-outline-success" onClick={() => navigate('/dashboard')}>
                <i className="fas fa-arrow-left"></i> Torna al Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Tabs */}
      <div className="mb-3">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <button className={`nav-link ${tab === 'generali' ? 'active' : ''}`} onClick={() => setTab('generali')} type="button">
              <i className="fas fa-users me-1"></i> Contatti Generali
            </button>
          </li>
          <li className="nav-item">
            <button className={`nav-link ${tab === 'prenotazioni' ? 'active' : ''}`} onClick={() => setTab('prenotazioni')} type="button">
              <i className="fas fa-calendar-alt me-1"></i> Contatti Prenotazioni
            </button>
          </li>
          <li className="nav-item">
            <button className={`nav-link ${tab === 'prenotazioni_nuovo' ? 'active' : ''}`} onClick={() => setTab('prenotazioni_nuovo')} type="button">
              <i className="fas fa-calendar-check me-1"></i> Contatti Prenotazioni Nuovo
            </button>
          </li>
        </ul>
      </div>
      {/* Tab content */}
      <div>
        {tab === 'generali' && (
          <React.Fragment>
            <Contatti
              key={contactsKeyGen}
              destinatariId={30}
              onSelectionChange={({ selectedRows, destinatariCount, emailCount, placeholders }) => {
                console.log('Contatti Generali - onSelectionChange ricevuto:', { selectedRows, destinatariCount, emailCount, placeholders });
                setSelectedRowsGen(selectedRows || []);
                setDestinatariCountGen(destinatariCount || 0);
                setEmailCountGen(emailCount || 0);
                setPlaceholdersGen(placeholders || []);
              }}
            />
            {/* 🔧 COMPOSIZIONE MAIL SEMPRE VISIBILE */}
            <ComposizioneMail
              servizio="Iniziative"
              destinatariCount={destinatariCountGen}
              emailCount={emailCountGen}
              placeholders={placeholdersGen}
              selectedRows={selectedRowsGen}
              onSendComplete={() => {
                setSelectedRowsGen([]);
                setDestinatariCountGen(0);
                setEmailCountGen(0);
                setContactsKeyGen(k => k + 1);
              }}
            />
          </React.Fragment>
        )}
        {tab === 'prenotazioni' && (
          <React.Fragment>
            <ContattiPrenotazione
              onIniziativaSelect={(idManager, iniziativaData) => {
                setSelectedIdManager(idManager);
                setSelectedIniziativa(iniziativaData);
                setSelectedPartecipanti([]);
                setDestinatariCountPartecipanti(0);
                setEmailCountPartecipanti(0);
                setPlaceholdersPartecipanti([]);
                // Genera segnaposto dall'iniziativa con prefisso INIZIATIVA_
                if (iniziativaData) {
                  const iniziativaPlaceholders = Object.keys(iniziativaData)
                    .filter(k => !['idManager', 'logo'].includes(k)) // Escludo campi non utili
                    .map(k => `{INIZIATIVA_${k.toUpperCase()}}`);
                  setPlaceholdersIniziativa(iniziativaPlaceholders);
                } else {
                  setPlaceholdersIniziativa([]);
                }
              }}
            />
            {/* Card partecipanti separata */}
            {selectedIdManager && (
              <ContattiPrenotazionePartecipanti
                idManager={selectedIdManager}
                onSelectionChange={({ selectedRows, destinatariCount, emailCount, placeholders }) => {
                  console.log('Partecipanti - onSelectionChange ricevuto:', { selectedRows, destinatariCount, emailCount, placeholders });
                  
                  setSelectedPartecipanti(selectedRows || []);
                  setDestinatariCountPartecipanti(destinatariCount || 0);
                  setEmailCountPartecipanti(emailCount || 0);
                  setPlaceholdersPartecipanti(placeholders || []);
                }}
              />
            )}
            {/* ComposizioneMail per i partecipanti selezionati */}
            {/* 🔧 COMPOSIZIONE MAIL SEMPRE VISIBILE (dopo selezione iniziativa) */}
            {selectedIdManager && (
              <ComposizioneMail
                servizio="IniziativePrenotazioni"
                destinatariCount={destinatariCountPartecipanti}
                emailCount={emailCountPartecipanti}
                placeholders={[...placeholdersIniziativa, ...placeholdersPartecipanti]}
                selectedRows={selectedPartecipanti}
                iniziativaData={selectedIniziativa}
                onSendComplete={() => {
                  setSelectedPartecipanti([]);
                  setDestinatariCountPartecipanti(0);
                  setEmailCountPartecipanti(0);
                }}
              />
            )}
          </React.Fragment>
        )}
        {tab === 'prenotazioni_nuovo' && (
          <React.Fragment>
            <ContattiPrenotazioneNuovo
              onIniziativaSelect={(id, iniziativaData) => {
                setSelectedIdNuovo(id);
                // Trasforma date per la sostituzione nei placeholder
                const iniziativaFormattata = iniziativaData ? {
                  ...iniziativaData,
                  dataDa: formatDateIT(iniziativaData.dataDa),
                  dataA: formatDateIT(iniziativaData.dataA),
                } : null;
                setSelectedIniziativaNuova(iniziativaFormattata);
                setSelectedIscrittiNuovo([]);
                setDestinatariCountNuovo(0);
                setEmailCountNuovo(0);
                setPlaceholdersIscrittiNuovo([]);
                if (iniziativaData) {
                  const pl = Object.keys(iniziativaData)
                    .filter(k => !['id', 'immagineUrl'].includes(k))
                    .map(k => `{INIZIATIVA_${k.toUpperCase()}}`);
                  setPlaceholdersIniziativaNuova(pl);
                } else {
                  setPlaceholdersIniziativaNuova([]);
                }
              }}
            />
            {selectedIdNuovo && (
              <ContattiPrenotazioneNuovoPartecipanti
                idIniziativa={selectedIdNuovo}
                onSelectionChange={({ selectedRows, destinatariCount, emailCount, placeholders }) => {
                  setSelectedIscrittiNuovo(selectedRows || []);
                  setDestinatariCountNuovo(destinatariCount || 0);
                  setEmailCountNuovo(emailCount || 0);
                  setPlaceholdersIscrittiNuovo(placeholders || []);
                }}
              />
            )}
            {selectedIdNuovo && (
              <ComposizioneMail
                servizio="IniziativePrenotazioni"
                destinatariCount={destinatariCountNuovo}
                emailCount={emailCountNuovo}
                placeholders={[...placeholdersIniziativaNuova, ...placeholdersIscrittiNuovo]}
                selectedRows={selectedIscrittiNuovo}
                iniziativaData={selectedIniziativaNuova}
                onSendComplete={() => {
                  setSelectedIscrittiNuovo([]);
                  setDestinatariCountNuovo(0);
                  setEmailCountNuovo(0);
                }}
              />
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

export default Iniziative;
